export const EMPTY_SHOP_INSIGHT_FILTER = {
  crm_open: false,
  crm_sla: false,
  credit_alert: "",
};

export function loadShopInsightFilter() {
  if (typeof window === "undefined") {
    return { ...EMPTY_SHOP_INSIGHT_FILTER };
  }

  try {
    const raw = localStorage.getItem("shopInsightFilter");
    if (!raw) {
      return { ...EMPTY_SHOP_INSIGHT_FILTER };
    }
    return { ...EMPTY_SHOP_INSIGHT_FILTER, ...JSON.parse(raw) };
  } catch {
    return { ...EMPTY_SHOP_INSIGHT_FILTER };
  }
}

export function saveShopInsightFilter(filter) {
  if (typeof window === "undefined") {
    return;
  }
  localStorage.setItem("shopInsightFilter", JSON.stringify(filter));
}

export function hasActiveShopInsightFilter(filter = EMPTY_SHOP_INSIGHT_FILTER) {
  return Boolean(filter.crm_open || filter.crm_sla || filter.credit_alert);
}

export function appendShopInsightFilters(params, filter = EMPTY_SHOP_INSIGHT_FILTER) {
  if (filter.crm_open) {
    params.set("crm_open", "1");
  }
  if (filter.crm_sla) {
    params.set("crm_sla", "1");
  }
  if (filter.credit_alert) {
    params.set("credit_alert", filter.credit_alert);
  }
  return params;
}
